export function getNameForLicensedFont(licensedFontName) {
  return `${licensedFontName}-style font`;
}
